import { render } from "./ClockPage.vue?vue&type=template&id=1853493b&scoped=true"
import script from "./ClockPage.vue?vue&type=script&lang=js"
export * from "./ClockPage.vue?vue&type=script&lang=js"

import "./ClockPage.vue?vue&type=style&index=0&id=1853493b&scoped=true&lang=css"
import "./ClockPage.vue?vue&type=style&index=1&id=1853493b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1853493b"]])

export default __exports__